<mat-form-field floatLabel="always" hideRequiredMarker subscriptSizing="dynamic">
  <mat-label>{{ label() | transloco }}</mat-label>

  <!-- Country calling code and national number share one field. -->
  <div class="control">
    <button (click)="$event.stopPropagation()" [attr.aria-label]="'form.label.dialCode' | transloco"
            [disabled]="disabled()" [matMenuTriggerFor]="dialCodeMenu" class="dial-code" type="button">
      {{ dialCode }}
      <mat-icon>arrow_drop_down</mat-icon>
    </button>

    <input (blur)="onBlur()" [errorStateMatcher]="errorStateMatcher" [formControl]="numberControl"
           [placeholder]="'form.placeholder.phoneNumber' | transloco" inputmode="tel" matInput>
  </div>

  <mat-error>{{ 'form.validation.phone' | transloco }}</mat-error>
</mat-form-field>

<mat-menu #dialCodeMenu class="dial-code-menu">
  <ng-template matMenuContent>
    @for (group of countryGroups; track group.labelKey) {
      <div class="group">{{ group.labelKey | transloco }}</div>
      @for (country of group.countries; track country.code) {
        <button (click)="selectCountry(country.code)" [class.selected]="country.code === countryCode()"
                mat-menu-item type="button">
          <span class="code">{{ country.dialCode }}</span>
          <span>{{ country.name }}</span>
        </button>
      }
    }
  </ng-template>
</mat-menu>
